import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SharedService } from 'src/app/shared/services/shared.service';
import { Roles } from 'src/app/shared/models/constants';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
    selector: 'app-add-edit-delete-btns',
    templateUrl: './add-edit-delete-btns.component.html',
    styleUrls: ['./add-edit-delete-btns.component.scss'],
    standalone: true,
    imports: [TooltipModule]
})
export class AddEditDeleteBtnsComponent implements ICellRendererAngularComp {
  params: any;
  editButtonsVisible = true;
  deleteButtonsNotVisible = false;

  editBtnVisible = true;
  deleteBtnVisible = true;
  addBtnVisible = false;

  constructor(public sharedService: SharedService) { }

  agInit(params: any): void {
    this.params = params;
    if (params.data['username'] === this.sharedService.logged_in_user.username) {
      this.editBtnVisible = true;
    } 
    if (this.sharedService.logged_in_user.role === Roles.admin && params.data['username'] !== this.sharedService.logged_in_user.username ) {
      this.deleteBtnVisible = true;
      this.editBtnVisible = true;
    }
    if (this.sharedService.logged_in_user.role === Roles.admin && params.data['username'] === this.sharedService.logged_in_user.username ) {
      this.addBtnVisible = true;
      this.editBtnVisible = true;
      this.deleteBtnVisible = true;
    }
  }
  refresh(params?: any): boolean {
    return true;
  }

  // Button functions
  editClick() {
    const rowData = {
      colValues: this.params.node.data,
      rowIndex: this.params.rowIndex,
    };
    this.params.editClicked(rowData);
  }
  deleteClick() {
    const rowData = {
      colValues: this.params.node.data,
      rowIndex: this.params.rowIndex,
    };
    this.params.deleteClicked(rowData);
  }
  addClick () {
    const rowData = {
      colValues: this.params.node.data,
      rowIndex: this.params.rowIndex,
    };
    this.params.addClicked(rowData);
  }
}
